import type { MarketExceptionType } from '@/constants/MarketExceptions/MarketExceptionTypes'
import { Base64 } from '@/lib/utils/shared/base64'
import type { UserType } from '@/store/types/user'

const generateOfficeRedirectURL = ({
  user,
  currentCountry,
  marketExceptions,
}: {
  user: UserType
  currentCountry: string
  marketExceptions: MarketExceptionType | null
}) => {
  const encodedToken = Base64.encode(user.token ?? '')
  const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production'

  const defaultOfficeUrl = isProduction
    ? `https://office.unicity.com/#/login/sl/${encodedToken}`
    : `https://office.unicityqa.com/develop/#/login/sl/${encodedToken}`

  if (!currentCountry) {
    return defaultOfficeUrl
  }

  const quickLinks = marketExceptions?.quickLinks
  const officeBaseUrl = quickLinks?.officeBaseUrl

  if (officeBaseUrl && typeof officeBaseUrl === 'string') {
    return officeBaseUrl
  }

  return defaultOfficeUrl
}

export default generateOfficeRedirectURL
